import React, { useMemo } from "react";
import { withTranslation } from "react-i18next";
import "rc-time-picker/assets/index.css";
import { Modal, ModalBody } from "reactstrap";
import crossIcon from "assets/images/cross.svg";
import Text from "components/Text";
import styles from "../OfficePolicyManagement.module.scss";
import { usePolicyAnalytics } from "repositories/office-policy-management-repository";
import { Spinner } from "reactstrap";
import AnalyticalChart from "./AnalyticalChart";

function PolicyAnalyticsModal({ t, isOpen, onClose, data }) {
  const policyId = data?.id ?? data?.policyId ?? data?.PolicyId ?? null;

  const { data: policyAnalyticsData, isLoading: isLoadingAnalytics } =
    usePolicyAnalytics(policyId, {
      enabled: !!policyId && isOpen,
    });

  // Transform API data to chart format, or use default if no data
  const chartData = useMemo(() => {
    if (policyAnalyticsData?.items?.length > 0) {
      // Map API response to chart data format
      return policyAnalyticsData.items.map((item) => ({
        name: item.statusName,
        value: item.count || 0,
        color: item.colorCode || "#3F78ED",
      }));
    }
    // Default/fallback data structure
    return [
      { name: "In Progress", value: 0, color: "#3F78ED" },
      { name: "Pending", value: 0, color: "#FCC539" },
      { name: "Accepted", value: 0, color: "#71D5B9" },
      { name: "Completed", value: 0, color: "#A9CF3D" },
      { name: "Overdue", value: 0, color: "#EE4F4F" },
      { name: "Not Assigned", value: 0, color: "#B5BAC1" },
    ];
  }, [policyAnalyticsData?.items]);

  const valuesCount = useMemo(() => {
    return (
      policyAnalyticsData?.items?.reduce(
        (acc, item) => acc + (item.count || 0),
        0,
      ) || 0
    );
  }, [policyAnalyticsData?.items]);
  return (
    <Modal
      isOpen={isOpen}
      toggle={() => onClose(false)}
      className="modal-dialog-centered modal-lg"
      modalClassName="custom-modal"
    >
      <span className="close-btn" onClick={() => onClose(false)}>
        <img src={crossIcon} alt="close" />
      </span>
      <ModalBody className={styles["add-employee-modal-dialog"]}>
        <Text size="25px" marginBottom="10px" weight="500" color="#111b45">
          <span className="modal-title-25">
            {t("officePolicyManagement.analyticsChart")}
          </span>
        </Text>
        {isLoadingAnalytics ? (
          <div style={{ padding: "1rem", textAlign: "center" }}>
            <Spinner animation="border" size="sm" className="loader-spinner" />
          </div>
        ) : valuesCount > 0 ? (
          <AnalyticalChart data={chartData} height={340} />
        ) : (
          <div className="text-center p-5">
            {t("officePolicyManagement.noAnalyticsData") || "No data available"}
          </div>
        )}
      </ModalBody>
    </Modal>
  );
}

export default withTranslation()(PolicyAnalyticsModal);
